import React from 'react';
import {
  TextField,
  useGetIdentity,
  DateField,
  BooleanField,
  FunctionField,
  Link,
} from 'react-admin';
import { usePageTitle } from '../../../components/usePageTitle';
import CustomizableDatagrid from '../../../utils/libs/CustomizableDatagridLib';
import { CUSTOM_STORAGE } from '../../../constants/list-column-custom-storage';
import { ShowIdButton } from '../../../components/ShowIdButton';
import { USER_CARD_STATUSE } from '../../../constants/statuses';

const DEFAULT_COLUMNS = ['id', 'status'];

const UserCardList = (props) => {
  usePageTitle(props);
  const { loading: identityLoading } = useGetIdentity();
  if (identityLoading) {
    return null;
  }

  return (
    <CustomizableDatagrid
      storage={CUSTOM_STORAGE}
      defaultColumns={DEFAULT_COLUMNS}
    >
      <ShowIdButton source="id" />
      <TextField
        sortable={false}
        source="user_account_id"
        label="User account ID"
      />
      <TextField sortable={false} source="user_id" label="User ID" />
      <TextField sortable={false} source="holder_name" label="Holder name" />
      <TextField
        sortable={false}
        source="holder_address"
        label="Holder adress"
      />
      <TextField sortable={false} source="mask" label="Mask" />
      <TextField sortable={false} source="description" label="Description" />
      <TextField sortable={false} source="account.balance" label="Balance" />
      <TextField sortable={false} source="favorite" label="Favorite" />
      <FunctionField
        label="Transactions"
        render={({ id }) => {
          const linkTo = {
            pathname: '/transactions-v2',
            search: `?filter=${encodeURIComponent(JSON.stringify({ 'cards||$eq': id }))}`,
          };
          return (
            <Link
              style={{
                border: '1px solid #3f51b5', color: '#3f51b5', padding: '8px', borderRadius: '4px',
              }}
              target="_blank"
              rel="noopener noreferrer"
              to={linkTo}
            >
              Transactions
            </Link>
          );
        }}
      />
      <FunctionField
        label="Status"
        render={({ status }) => <span>{USER_CARD_STATUSE[status] || status}</span>}
      />
      <DateField sortable={false} source="ordered_at" />
      <DateField sortable={false} source="ordered_until" />
      <BooleanField
        sortable={false}
        source="topup_waiting"
        label="Topup waiting"
      />
      <TextField sortable={false} source="tariff_id" label="Tariff id" />
      <BooleanField sortable={false} source="need_amount" label="Need amount" />
      <BooleanField
        sortable={false}
        source="limits_equals"
        label="Limit equals"
      />
      <DateField sortable={false} source="created_at" />
    </CustomizableDatagrid>
  );
};
export default UserCardList;
